import { render, staticRenderFns } from "./CreatePickl.vue?vue&type=template&id=472ce390&scoped=true&"
import script from "./CreatePickl.vue?vue&type=script&lang=js&"
export * from "./CreatePickl.vue?vue&type=script&lang=js&"
import style0 from "./CreatePickl.vue?vue&type=style&index=0&id=472ce390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472ce390",
  null
  
)

export default component.exports